module.exports = __webpack_public_path__ + "img/GX11X5.png";